<template>
  <NavigationBar></NavigationBar>
  <div class="flashMessage" v-if="GStore.flashMessage">
    {{ GStore.flashMessage }}
  </div>
  <!-- <NavigationBarAdmin v-if="loggedIn"></NavigationBarAdmin> -->
  <router-view></router-view>
</template>


<script>
import { authComputed } from "@/store/helpers";
import axios from "axios";
import NavigationBar from "@/components/Navigation/NavigationBar.vue";
import FooterBar from "@/components/Footer.vue";

import NavigationBarAdmin from "@/components/Navigation/NavigationBarAdmin.vue";

export default {
  name: "App",
  components: { NavigationBar, NavigationBarAdmin, FooterBar },
  inject: ["GStore"],
  computed: {
    ...authComputed,
  },

  created() {
    const userString = localStorage.getItem("user");
    if (userString) {
      const userData = JSON.parse(userString);
      this.$store.commit("SET_USER_DATA", userData);
    }
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response.status === 403) {
          this.$store.dispatch("logout");
        }
        return Promise.reject(error);
      }
    );
  },
};
</script>


<style lang="less">
@import "@/styles/project.less";
@import "@/styles/dark-mode.less";
</style>